import { Fragment, memo, ReactElement } from 'react';
import { Form, Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import {
  FiltersFormCirculationArea,
  FitersCadastralVM,
} from 'system/pages/toponymy/circulation-area/list/types';
import FiltersCirculationArea from './filters-circulation-area';
import FilterCadastral from './filter-cadastral';
import { useFilterTable } from 'shell/hooks/use-filter-table';
import { regexOnlyNumber } from 'shell/constants/regex';

const validationSchemaFilterCadastral = yup
  .object({
    sheet: yup
      .string()
      .nullable()
      .required('Campo obbligatorio')
      .matches(regexOnlyNumber, 'Il campo è numerico'),
    particle: yup.string().nullable(),
    subordinate: yup.string().nullable(),
  })
  .test('', '', (values) => {
    const castedValues = (values || {}) as unknown as FitersCadastralVM;

    const errors = [];

    if (castedValues.sheet && castedValues.subordinate && !castedValues.particle) {
      errors.push(new yup.ValidationError('Campo obbligatorio', undefined, 'particle'));
    }

    if (castedValues.particle) {
      if (
        castedValues.particle?.includes('*') &&
        !(
          (castedValues.particle?.endsWith('*') && !castedValues.particle?.startsWith('*')) ||
          (!castedValues.particle?.endsWith('*') && castedValues.particle?.startsWith('*'))
        )
      ) {
        errors.push(
          new yup.ValidationError(
            "Il campo può contenere l'asterisco solo all'inizio o alla fine della stringa",
            undefined,
            'particle'
          )
        );
      }
    }

    if (castedValues.subordinate) {
      if (
        castedValues.subordinate?.includes('*') &&
        !(
          (castedValues.subordinate?.endsWith('*') && !castedValues.subordinate?.startsWith('*')) ||
          (!castedValues.subordinate?.endsWith('*') && castedValues.subordinate?.startsWith('*'))
        )
      ) {
        errors.push(
          new yup.ValidationError(
            "Il campo può contenere l'asterisco solo all'inizio o alla fine della stringa",
            undefined,
            'subordinate'
          )
        );
      }
    }

    if (errors.length > 0) {
      return new yup.ValidationError(errors);
    }

    return true;
  });

interface FiltersListToponymyProps {
  filterCirculationAreaForm: FormikProps<FiltersFormCirculationArea>;
  openCirculationArea?: boolean;
  setOpenCirculationArea: (value: boolean) => void;
  openCadastral?: boolean;
  setOpenCadastral: (value: boolean) => void;
  handleSubmitFilterCadastral: (values: FitersCadastralVM) => void;
}

const FiltersListToponymyComponent = ({
  filterCirculationAreaForm,
  openCirculationArea = false,
  setOpenCirculationArea,
  openCadastral = false,
  setOpenCadastral,
  handleSubmitFilterCadastral,
}: FiltersListToponymyProps): ReactElement => {
  const filterTable = useFilterTable<FitersCadastralVM>();
  return (
    <Fragment>
      <FiltersCirculationArea
        filterCirculationAreaForm={filterCirculationAreaForm}
        open={openCirculationArea}
        setOpen={setOpenCirculationArea}
      />
      <Formik
        initialValues={
          filterTable.values
            ? {
                particle: filterTable.values.particle,
                sheet: filterTable.values.sheet,
                subordinate: filterTable.values.subordinate,
              }
            : ({
                sheet: undefined,
                particle: undefined,
                subordinate: undefined,
              } as FitersCadastralVM)
        }
        enableReinitialize
        onSubmit={handleSubmitFilterCadastral}
        validateOnMount
        validationSchema={validationSchemaFilterCadastral}
      >
        <Form>
          <FilterCadastral open={openCadastral} setOpen={setOpenCadastral} />
        </Form>
      </Formik>
    </Fragment>
  );
};

FiltersListToponymyComponent.displayName = 'Filters List Toponymy component';

const FiltersListToponymy = memo(FiltersListToponymyComponent);

export default FiltersListToponymy;
